import React from 'react';
import {Link} from 'react-router-dom';

export default class BoxPublicacoes extends React.Component {
  jaAprovada(){
    this.props.publicacoes.map(publicacao => {
      publicacao.paginas.map(pagina => {
        if(pagina.comentarios.length>0){
          return true;
        }
      })
    });
    return false;
  }
  getUrlImg(){
    let tipo = this.props.tipo
    switch (tipo) {
      case "paginacao":
        return "./images/icons-aprov/CONVITE.png"
      case "capa-dura":
        return "./images/icons-aprov/CAPA-DURA.png"
      case "embalagens":
        return "./images/icons-aprov/EMBALAGEM.png"
      case "encarte":
        return "./images/icons-aprov/ENCARTE.png"
      case "convite-simples":
        return "./images/icons-aprov/CONVITE-SIMPLES.png"
      case "senha-de-entrada":
        return "./images/icons-aprov/SENHA.png"
      case "missal":
        return "./images/icons-aprov/MISSAL.png"
      case "outros-produtos":
        return "./images/icons-aprov/OUTROS-PRODUTOS.png"
      case "personalizadas":
        return "./images/icons-aprov/OUTROS-PRODUTOS.png"
      default:

    }
  }
  getStatusStyle() {
    let statusConfig = {
      backgroundColor: '',
      color: '',
      text: '',
      icon: ''
    };

    if(this.props.publicacoes.length > 0 && this.props.publicacoes[0].dataAprovacao) {
      if (this.props.publicacoes[0].status === "aprovado com correções") {
        statusConfig = {
          backgroundColor: '#10b981',
          color: '#fff',
          text: 'Aprovada com Correções',
          icon: 'fa-check-circle'
        };
      } else {
        statusConfig = {
          backgroundColor: '#10b981',
          color: '#fff',
          text: 'Aprovada',
          icon: 'fa-check-circle'
        };
      }
    } else {
      statusConfig = {
        backgroundColor: '#3b82f6',
        color: '#fff',
        text: 'Em andamento',
        icon: 'fa-spinner'
      };
      if(this.props.publicacoes.length > 0 && this.props.publicacoes[0].status === "aguardando") {
        statusConfig = {
          backgroundColor: '#f59e0b',
          color: '#fff',
          text: 'Nova publicação',
          icon: 'fa-bell'
        };
      }
    }
    return statusConfig;
  }

  render(){
    const statusStyle = this.getStatusStyle();

    return(
      <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12" style={{marginBottom: 20, padding: '0 10px'}}>
        <Link
          onClick={this.props.publicacoes.length===0 ? (event) => event.preventDefault() : null}
          to={`/publicacoes/${this.props.tipo ? this.props.tipo : ""}`}
          style={{textDecoration: 'none'}}
        >
          <div style={{
            background: 'linear-gradient(135deg, #222d32 0%, #1a2228 100%)',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.3s ease',
            position: 'relative',
            cursor: this.props.publicacoes.length === 0 ? 'not-allowed' : 'pointer',
            opacity: this.props.publicacoes.length === 0 ? 0.6 : 1
          }}
          className="publicacao-card"
          >
            {/* Badge de Status */}
            <div style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.color,
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '11px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              zIndex: 3,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
            }}>
              <i className={`fa ${statusStyle.icon}`} style={{fontSize: '12px'}}></i>
              {statusStyle.text}
            </div>

            {/* Conteúdo Principal */}
            <div style={{padding: '24px 20px', position: 'relative', zIndex: 2}}>
              {/* Ícone */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '16px'
              }}>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  padding: '16px',
                  display: 'inline-flex',
                  backdropFilter: 'blur(10px)'
                }}>
                  <img
                    src={this.getUrlImg()}
                    style={{height: 56, width: 'auto'}}
                    alt="icone"
                  />
                </div>
              </div>

              {/* Título */}
              <h3 style={{
                color: '#fff',
                fontSize: '18px',
                fontWeight: '700',
                textAlign: 'center',
                margin: '0 0 16px 0',
                lineHeight: '1.3',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
              }}>
                {this.props.titulo}
              </h3>

              {/* Informação de Data */}
              <div style={{
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '8px',
                padding: '12px',
                textAlign: 'center'
              }}>
                <div style={{
                  color: '#cbd5e0',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  {this.props.publicacoes.length > 0 ? (
                    <>
                      <i className="fa fa-calendar" style={{marginRight: '6px'}}></i>
                      Publicado {new Date(this.props.publicacoes[0].dataPublicacao).toLocaleDateString('pt-BR')}
                      <br/>
                      <span style={{fontSize: '11px', opacity: 0.8}}>
                        {new Date(this.props.publicacoes[0].dataPublicacao).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})}
                      </span>
                    </>
                  ) : (
                    <>
                      <i className="fa fa-info-circle" style={{marginRight: '6px'}}></i>
                      Não há publicações
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Footer com ação */}
            <div style={{
              background: 'rgba(0, 0, 0, 0.25)',
              padding: '12px 20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <span style={{
                color: '#fff',
                fontSize: '13px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                Ver detalhes
                <i className="fa fa-arrow-circle-right"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* Botão de Histórico */}
        {
          this.props.tipoUsuario && this.props.tipoUsuario === "formando" ?
            null
          : <div style={{textAlign: "center", marginTop: 12}}>
              <button
                className="btn btn-link"
                onClick={() => this.props.historico(this.props.publicacoes)}
                data-toggle="modal"
                data-target="#modal-historico"
                type="button"
                style={{
                  boxShadow: "0 0 0 0",
                  outline: "0 none",
                  color: '#718096',
                  fontSize: '13px',
                  fontWeight: '500',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#2d3748'}
                onMouseLeave={(e) => e.target.style.color = '#718096'}
              >
                <i className="fa fa-history"></i> &nbsp; Histórico de Publicações
              </button>
            </div>
        }
      </div>
    )
  }
}
